
import { useState } from "react"
import {
  Box,
  Paper,
  Tabs,
  Tab,
  Typography,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Card,
  CardContent,
  CardActions,
  Chip,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Alert,
  Snackbar,
  useTheme,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Switch,
  FormControlLabel,
  Avatar,
  Stack,
  Badge,
} from "@mui/material"
import {
  Search,
  Add,
  Edit,
  Delete,
  Person,
  PersonAdd,
  PersonRemove,
  Work,
  LocationOn,
  ExpandMore,
  Close,
  Save,
  Cancel,
  Update,
  Settings,
  Group,
  Business,
  AdminPanelSettings,
  SupervisorAccount,
  AccountCircle,
} from "@mui/icons-material"

// User roles enum
const USER_ROLES = {
  USER: "user",
  ADMIN: "admin",
  SUPER_ADMIN: "super_admin",
} 


// Mock data - replace with actual API calls
const mockProjects = [
  {
    _id: "674d60b0da4f29d9e6a98083",
    projectID: "674b469c0d6a6e9c926e179c",
    projectStr: "IndiaDVCKTPS",
    dataYear: {
      year: ["2024"],
      month: [
        {
          year: "2024",
          month: ["Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"],
        },
      ],
    },
    plantDetail: {
      dcCapacity: "13.09 MWp",
      acCapacity: "10.09 MW",
      dataSheet: "Modules, Inverter(s) and Transformer(s)",
      cabel: "Cable Details",
      sld: "DC SLD and AC SLD",
      noOfInverter: 4,
      inverterSpecification: "1.92 MVA, 3.02 MVA & 2.11 MVA Fimer",
      inverterType: "Central",
      noOfscbsmb: 45,
      noOfString: 1303,
      stringType: "Y connector",
      string: "SCB",
    },
    plantLocation: {
      title: "DVC Koderma",
      url: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d863.4380915717746!2d85.55874940454197!3d24.397414170998374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2s!5e1!3m2!1sen!2sin!4v1731251451050!5m2!1sen!2sin",
      name: "13.09 MWp Solar Plant at DVC Koderma",
      lattitude: 24.4,
      longitude: 85.56,
      altitude: "380 m",
    },
    plantLoss: null,
    plantDataAvailability: {
      netContractual: true,
      netPVsyst: false,
      inverterDeviation: false,
      inverterEfficiency: true,
      scbSmbDeviation: true,
      timeInterval: "5_min",
      dayData: true,
      isDownloadAllowed: true,
      realtimeData: true,
    },
    calculationFormula: {
      actualPR: "((net_energy/((1+((-0.35)/100)*(module_temp-25))*dc_capacity*actual_gii))*100)",
    },
    calculationData: {
      ac_capacity: 10000,
      dc_capacity: 13090,
    },
    assignedUsers: [
      { id: "1", email: "john.doe@example.com", username: "johndoe", role: "admin"  },
      { id: "2", email: "jane.smith@example.com", username: "janesmith", role: "user"  },
    ],
  },
  {
    _id: "674d60b0da4f29d9e6a98084",
    projectID: "674b469c0d6a6e9c926e179d",
    projectStr: "SolarParkDelhi",
    dataYear: {
      year: ["2024"],
      month: [
        {
          year: "2024",
          month: ["Jan", "Feb", "Mar", "Apr", "May"],
        },
      ],
    },
    plantDetail: {
      dcCapacity: "25.5 MWp",
      acCapacity: "20.0 MW",
      dataSheet: "Modules, Inverter(s) and Transformer(s)",
      cabel: "Cable Details",
      sld: "DC SLD and AC SLD",
      noOfInverter: 8,
      inverterSpecification: "2.5 MVA Central Inverters",
      inverterType: "Central",
      noOfscbsmb: 85,
      noOfString: 2550,
      stringType: "MC4 connector",
      string: "SCB",
    },
    plantLocation: {
      title: "Delhi Solar Park",
      url: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d863.4380915717746!2d77.2090!3d28.6139!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2s!5e1!3m2!1sen!2sin!4v1731251451050!5m2!1sen!2sin",
      name: "25.5 MWp Solar Plant at Delhi",
      lattitude: 28.6139,
      longitude: 77.209,
      altitude: "216 m",
    },
    plantLoss: null,
    plantDataAvailability: {
      netContractual: true,
      netPVsyst: true,
      inverterDeviation: true,
      inverterEfficiency: true,
      scbSmbDeviation: true,
      timeInterval: "1_min",
      dayData: true,
      isDownloadAllowed: true,
      realtimeData: true,
    },
    calculationFormula: {
      actualPR: "((net_energy/((1+((-0.4)/100)*(module_temp-25))*dc_capacity*actual_gii))*100)",
    },
    calculationData: {
      ac_capacity: 20000,
      dc_capacity: 25500,
    },
    assignedUsers: [
      { id: "3", email: "mike.wilson@example.com", username: "mikewilson", role: "user"  },
      { id: "1", email: "john.doe@example.com", username: "johndoe", role: "admin"  },
    ],
  },
]

const mockUsers = [
  { id: "1", email: "john.doe@example.com", username: "johndoe", role: "admin"  },
  { id: "2", email: "jane.smith@example.com", username: "janesmith", role: "user"  },
  { id: "3", email: "mike.wilson@example.com", username: "mikewilson", role: "user"  },
  { id: "4", email: "sarah.johnson@example.com", username: "sarahjohnson", role: "super_admin"  },
  { id: "5", email: "david.brown@example.com", username: "davidbrown", role: "admin"  },
]



function TabPanel(props) {
  const { children, value, index, ...other } = props
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: { xs: 1.5, md: 2.5 } }}>{children}</Box>}
    </div>
  )
}

function a11yProps(index) {
  return {
    id: `admin-tab-${index}`,
    "aria-controls": `admin-tabpanel-${index}`,
  }
}

export default function AdminDashboard() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  const [tabValue, setTabValue] = useState(0)
  const [projects, setProjects] = useState(mockProjects)
  const [users, setUsers] = useState(mockUsers)
  const [searchTerm, setSearchTerm] = useState("")
  const [userSearchTerm, setUserSearchTerm] = useState("")
  const [selectedProject, setSelectedProject] = useState(null)
  const [selectedUser, setSelectedUser] = useState(null)
  const [openProjectDialog, setOpenProjectDialog] = useState(false)
  const [openUserDialog, setOpenUserDialog] = useState(false)
  const [openCreateDialog, setOpenCreateDialog] = useState(false)
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false)
  const [openUserRoleDialog, setOpenUserRoleDialog] = useState(false)
  const [updateProject, setUpdateProject] = useState(null)
  const [editingUser, setEditingUser] = useState(null)
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" })
  const [newProject, setNewProject] = useState({
    projectStr: "",
    dataYear: { year: ["2024"], month: [{ year: "2024", month: [] }] },
    plantDetail: {
      dcCapacity: "",
      acCapacity: "",
      dataSheet: "",
      cabel: "",
      sld: "",
      noOfInverter: 0,
      inverterSpecification: "",
      inverterType: "Central",
      noOfscbsmb: 0,
      noOfString: 0,
      stringType: "",
      string: "",
    },
    plantLocation: {
      title: "",
      url: "",
      name: "",
      lattitude: 0,
      longitude: 0,
      altitude: "",
    },
    plantDataAvailability: {
      netContractual: true,
      netPVsyst: false,
      inverterDeviation: false,
      inverterEfficiency: true,
      scbSmbDeviation: true,
      timeInterval: "5_min",
      dayData: true,
      isDownloadAllowed: true,
      realtimeData: true,
    },
    calculationFormula: {
      actualPR: "",
    },
    calculationData: {
      ac_capacity: 0,
      dc_capacity: 0,
    },
  })

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  const filteredProjects = projects.filter(
    (project) =>
      project.projectStr.toLowerCase().includes(searchTerm.toLowerCase()) ||
      project.plantLocation.title.toLowerCase().includes(searchTerm.toLowerCase()),
  )

  const filteredUsers = users.filter(
    (user) =>
      user.email.toLowerCase().includes(userSearchTerm.toLowerCase()) ||
      user.username.toLowerCase().includes(userSearchTerm.toLowerCase()),
  )

  const getUserProjects = (userId) => {
    return projects.filter((project) => project.assignedUsers?.some((user) => user.id === userId))
  }

  const addUserToProject = (projectId, user) => {
    setProjects((prev) =>
      prev.map((project) => {
        if (project._id === projectId) {
          const isAlreadyAssigned = project.assignedUsers?.some((u) => u.id === user.id)
          if (!isAlreadyAssigned) {
            return {
              ...project,
              assignedUsers: [...(project.assignedUsers || []), user],
            }
          }
        }
        return project
      }),
    )
    setSnackbar({ open: true, message: "User added to project successfully", severity: "success" })
  }

  const removeUserFromProject = (projectId, userId) => {
    setProjects((prev) =>
      prev.map((project) => {
        if (project._id === projectId) {
          return {
            ...project,
            assignedUsers: project.assignedUsers?.filter((user) => user.id !== userId) || [],
          }
        }
        return project
      }),
    )
    setSnackbar({ open: true, message: "User removed from project successfully", severity: "success" })
  }

  const updateUserRole = (userId, newRole) => {
    setUsers((prev) => prev.map((user) => (user.id === userId ? { ...user, role: newRole } : user)))

    // Also update the role in projects
    setProjects((prev) =>
      prev.map((project) => ({
        ...project,
        assignedUsers:
          project.assignedUsers?.map((user) => (user.id === userId ? { ...user, role: newRole } : user)) || [],
      })),
    )

    setSnackbar({ open: true, message: "User role updated successfully", severity: "success" })
  }

  const createNewProject = () => {
    const project = {
      ...newProject,
      _id: Date.now().toString(),
      projectID: Date.now().toString(),
      assignedUsers: [],
    }
    setProjects((prev) => [...prev, project])
    setOpenCreateDialog(false)
    setSnackbar({ open: true, message: "Project created successfully", severity: "success" })
    resetNewProject()
  }

  const handleUpdateProject = () => {
    if (updateProject) {
      setProjects((prev) => prev.map((project) => (project._id === updateProject._id ? updateProject : project)))
      setOpenUpdateDialog(false)
      setUpdateProject(null)
      setSnackbar({ open: true, message: "Project updated successfully", severity: "success" })
    }
  }

  const resetNewProject = () => {
    setNewProject({
      projectStr: "",
      dataYear: { year: ["2024"], month: [{ year: "2024", month: [] }] },
      plantDetail: {
        dcCapacity: "",
        acCapacity: "",
        dataSheet: "",
        cabel: "",
        sld: "",
        noOfInverter: 0,
        inverterSpecification: "",
        inverterType: "Central",
        noOfscbsmb: 0,
        noOfString: 0,
        stringType: "",
        string: "",
      },
      plantLocation: {
        title: "",
        url: "",
        name: "",
        lattitude: 0,
        longitude: 0,
        altitude: "",
      },
      plantDataAvailability: {
        netContractual: true,
        netPVsyst: false,
        inverterDeviation: false,
        inverterEfficiency: true,
        scbSmbDeviation: true,
        timeInterval: "5_min",
        dayData: true,
        isDownloadAllowed: true,
        realtimeData: true,
      },
      calculationFormula: {
        actualPR: "",
      },
      calculationData: {
        ac_capacity: 0,
        dc_capacity: 0,
      },
    })
  }

  const getInitials = (name) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2)
  }

  const getAvatarColor = (id) => {
    const colors = ["#1976d2", "#388e3c", "#f57c00", "#d32f2f", "#7b1fa2", "#0288d1"]
    return colors[Number.parseInt(id) % colors.length]
  }

  const getRoleIcon = (role) => {
    switch (role) {
      case "super_admin":
        return <SupervisorAccount fontSize="small" />
      case "admin":
        return <AdminPanelSettings fontSize="small" />
      default:
        return <AccountCircle fontSize="small" />
    }
  }

  const getRoleColor = (role) => {
    switch (role) {
      case "super_admin":
        return "error"
      case "admin":
        return "warning"
      default:
        return "default"
    }
  }

  const getRoleLabel = (role) => {
    switch (role) {
      case "super_admin":
        return "Super Admin"
      case "admin":
        return "Admin"
      default:
        return "User"
    }
  }

  return (
    <Box sx={{ width: "100%", bgcolor: "#f8fafc", minHeight: "100vh" }}>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          mb: 2,
          borderRadius: 2,
          overflow: "hidden",
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        }}
      >
        <Box
          sx={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            px: { xs: 2, md: 3 },
            py: 2.5,
          }}
        >
          <Typography variant="h4" component="h1" fontWeight="600" gutterBottom sx={{ fontSize: "1.75rem" }}>
            Admin Dashboard
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, fontWeight: 400, fontSize: "0.95rem" }}>
            Manage projects, users, and assignments
          </Typography>
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="admin dashboard tabs"
            variant={isMobile ? "scrollable" : "standard"}
            scrollButtons="auto"
            sx={{
              px: { xs: 2, md: 3 },
              "& .MuiTab-root": {
                fontSize: "0.875rem",
                fontWeight: 500,
                textTransform: "none",
                minHeight: 56,
                py: 1.5,
              },
            }}
          >
            <Tab label="Projects" icon={<Work />} {...a11yProps(0)} />
            <Tab label="Users & Projects" icon={<Person />} {...a11yProps(1)} />
            <Tab label="User Management" icon={<Settings />} {...a11yProps(2)} />
          </Tabs>
        </Box>

        {/* Projects Tab */}
        <TabPanel value={tabValue} index={0}>
          <Box sx={{ mb: 3, display: "flex", gap: 2, flexWrap: "wrap", alignItems: "center" }}>
            <TextField
              placeholder="Search projects by name or location..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: <Search sx={{ mr: 1, color: "text.secondary" }} />,
              }}
              sx={{
                flexGrow: 1,
                minWidth: 280,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 1.5,
                },
              }}
              size="small"
            />
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setOpenCreateDialog(true)}
              sx={{
                borderRadius: 1.5,
                px: 2.5,
                py: 1,
                fontSize: "0.875rem",
                fontWeight: 500,
                textTransform: "none",
                boxShadow: "0 2px 8px rgba(25, 118, 210, 0.3)",
              }}
            >
              Create Project
            </Button>
          </Box>

          <Grid container spacing={2.5}>
            {filteredProjects.map((project) => (
              <Grid item xs={12} md={6} lg={4} key={project._id}>
                <Card
                  sx={{
                    height: 360,
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: 2,
                    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
                    },
                  }}
                >
                  <CardContent sx={{ flexGrow: 1, p: 2.5 }}>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
                      <Avatar
                        sx={{
                          bgcolor: "primary.main",
                          mr: 1.5,
                          width: 40,
                          height: 40,
                          fontSize: "1rem",
                          fontWeight: 500,
                        }}
                      >
                        <Business />
                      </Avatar>
                      <Box>
                        <Typography variant="h6" component="h2" fontWeight="600" sx={{ mb: 0.5, fontSize: "1.1rem" }}>
                          {project.projectStr}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ display: "flex", alignItems: "center", fontSize: "0.8rem" }}
                        >
                          <LocationOn sx={{ fontSize: 14, mr: 0.5 }} />
                          {project.plantLocation.title}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ mb: 2 }}>
                      <Grid container spacing={1.5}>
                        <Grid item xs={6}>
                          <Box sx={{ textAlign: "center", p: 1.5, bgcolor: "#f0f9ff", borderRadius: 1.5 }}>
                            <Typography variant="body1" fontWeight="600" color="primary.main" sx={{ fontSize: "1rem" }}>
                              {project.plantDetail.dcCapacity}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.7rem" }}>
                              DC Capacity
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box sx={{ textAlign: "center", p: 1.5, bgcolor: "#f0fdf4", borderRadius: 1.5 }}>
                            <Typography variant="body1" fontWeight="600" color="success.main" sx={{ fontSize: "1rem" }}>
                              {project.plantDetail.acCapacity}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.7rem" }}>
                              AC Capacity
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>

                    <Box sx={{ mb: 2 }}>
                      <Typography variant="body2" sx={{ mb: 1, fontSize: "0.8rem" }}>
                        <strong>Inverters:</strong> {project.plantDetail.noOfInverter} | <strong>Strings:</strong>{" "}
                        {project.plantDetail.noOfString}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography variant="subtitle2" fontWeight="500" sx={{ mb: 1, fontSize: "0.85rem" }}>
                        Assigned Users ({project.assignedUsers?.length || 0})
                      </Typography>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, minHeight: 32 }}>
                        {project.assignedUsers?.slice(0, 2).map((user) => (
                          <Chip
                            key={user.id}
                            label={user.username}
                            size="small"
                            variant="outlined"
                            icon={getRoleIcon(user.role)}
                            color={getRoleColor(user.role)}
                            sx={{
                              borderRadius: 1.5,
                              fontWeight: 400,
                              fontSize: "0.7rem",
                              height: 24,
                            }}
                          />
                        ))}
                        {(project.assignedUsers?.length || 0) > 2 && (
                          <Chip
                            label={`+${(project.assignedUsers?.length || 0) - 2} more`}
                            size="small"
                            variant="outlined"
                            color="primary"
                            sx={{ borderRadius: 1.5, fontSize: "0.7rem", height: 24 }}
                          />
                        )}
                        {(project.assignedUsers?.length || 0) === 0 && (
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontStyle: "italic", fontSize: "0.75rem" }}
                          >
                            No users assigned
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </CardContent>
                  <CardActions sx={{ p: 2.5, pt: 0 }}>
                    <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                      <Button
                        size="small"
                        startIcon={<Edit />}
                        onClick={() => {
                          setSelectedProject(project)
                          setOpenProjectDialog(true)
                        }}
                        sx={{ textTransform: "none", fontWeight: 500, fontSize: "0.75rem" }}
                      >
                        Manage Users
                      </Button>
                      <Button
                        size="small"
                        startIcon={<Update />}
                        onClick={() => {
                          setUpdateProject({ ...project })
                          setOpenUpdateDialog(true)
                        }}
                        color="secondary"
                        sx={{ textTransform: "none", fontWeight: 500, fontSize: "0.75rem" }}
                      >
                        Update
                      </Button>
                    </Stack>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </TabPanel>

        {/* Users & Projects Tab */}
        <TabPanel value={tabValue} index={1}>
          <Box sx={{ mb: 3 }}>
            <TextField
              placeholder="Search users by name or email..."
              value={userSearchTerm}
              onChange={(e) => setUserSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: <Search sx={{ mr: 1, color: "text.secondary" }} />,
              }}
              fullWidth
              sx={{
                maxWidth: 450,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 1.5,
                },
              }}
              size="small"
            />
          </Box>

          <Grid container spacing={2.5}>
            {filteredUsers.map((user) => {
              const userProjects = getUserProjects(user.id)
              return (
                <Grid item xs={12} md={6} lg={4} key={user.id}>
                  <Card
                    sx={{
                      height: 360,
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: 2,
                      boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
                      },
                    }}
                  >
                    <CardContent sx={{ flexGrow: 1, p: 2.5 }}>
                      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                        <Avatar
                          sx={{
                            bgcolor: getAvatarColor(user.id),
                            mr: 1.5,
                            width: 48,
                            height: 48,
                            fontSize: "1.1rem",
                            fontWeight: 600,
                          }}
                        >
                          {getInitials(user.username)}
                        </Avatar>
                        <Box sx={{ flexGrow: 1 }}>
                          <Typography variant="h6" component="h2" fontWeight="600" sx={{ mb: 0.5, fontSize: "1.1rem" }}>
                            {user.username}
                          </Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}>
                            {user.email}
                          </Typography>
                        </Box>
                        <IconButton
                          size="small"
                          onClick={() => {
                            setEditingUser(user)
                            setOpenUserRoleDialog(true)
                          }}
                          sx={{ ml: 1 }}
                        >
                          <Edit fontSize="small" />
                        </IconButton>
                      </Box>

                      <Box sx={{ mb: 2 }}>
                        <Chip
                          label={getRoleLabel(user.role)}
                          icon={getRoleIcon(user.role)}
                          color={getRoleColor(user.role)}
                          size="small"
                          sx={{ fontWeight: 500, fontSize: "0.75rem" }}
                        />
                      </Box>

                      <Box sx={{ mb: 1.5 }}>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
                          <Typography variant="subtitle2" fontWeight="500" sx={{ fontSize: "0.85rem" }}>
                            Assigned Projects
                          </Typography>
                          <Badge
                            badgeContent={userProjects.length}
                            color="primary"
                            sx={{
                              "& .MuiBadge-badge": {
                                fontSize: "0.65rem",
                                fontWeight: 500,
                              },
                            }}
                          >
                            <Group color="action" fontSize="small" />
                          </Badge>
                        </Box>

                        <Box sx={{ maxHeight: 160, overflowY: "auto" }}>
                          {userProjects.length > 0 ? (
                            <List dense sx={{ py: 0 }}>
                              {userProjects.map((project) => (
                                <ListItem key={project._id} sx={{ px: 0, py: 0.5 }}>
                                  <ListItemText
                                    primary={
                                      <Typography variant="body2" fontWeight="500" sx={{ fontSize: "0.8rem" }}>
                                        {project.projectStr}
                                      </Typography>
                                    }
                                    secondary={
                                      <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.7rem" }}>
                                        {project.plantLocation.title}
                                      </Typography>
                                    }
                                  />
                                  <ListItemSecondaryAction>
                                    <IconButton
                                      edge="end"
                                      size="small"
                                      onClick={() => removeUserFromProject(project._id, user.id)}
                                      color="error"
                                      sx={{
                                        "&:hover": {
                                          bgcolor: "error.light",
                                          color: "white",
                                        },
                                      }}
                                    >
                                      <PersonRemove fontSize="small" />
                                    </IconButton>
                                  </ListItemSecondaryAction>
                                </ListItem>
                              ))}
                            </List>
                          ) : (
                            <Box
                              sx={{
                                textAlign: "center",
                                py: 3,
                                color: "text.secondary",
                              }}
                            >
                              <Group sx={{ fontSize: 36, mb: 1, opacity: 0.3 }} />
                              <Typography variant="body2" sx={{ fontStyle: "italic", fontSize: "0.75rem" }}>
                                No projects assigned
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </CardContent>
                    <CardActions sx={{ p: 2.5, pt: 0 }}>
                      <Button
                        fullWidth
                        startIcon={<PersonAdd />}
                        onClick={() => {
                          setSelectedUser(user)
                          setOpenUserDialog(true)
                        }}
                        variant="outlined"
                        sx={{
                          textTransform: "none",
                          fontWeight: 500,
                          borderRadius: 1.5,
                          py: 0.75,
                          fontSize: "0.8rem",
                        }}
                      >
                        Assign Projects
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              )
            })}
          </Grid>
        </TabPanel>

        {/* User Management Tab */}
        <TabPanel value={tabValue} index={2}>
          <Typography variant="h5" fontWeight="600" gutterBottom sx={{ mb: 3, fontSize: "1.4rem" }}>
            Project-wise User Management
          </Typography>
          {projects.map((project) => (
            <Accordion
              key={project._id}
              sx={{
                mb: 2,
                borderRadius: 2,
                boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                "&:before": { display: "none" },
                "&.Mui-expanded": {
                  boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                sx={{
                  px: 2.5,
                  py: 1.5,
                  "& .MuiAccordionSummary-content": {
                    alignItems: "center",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: "100%" }}>
                  <Avatar sx={{ bgcolor: "primary.main", width: 36, height: 36 }}>
                    <Business />
                  </Avatar>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="h6" fontWeight="600" sx={{ fontSize: "1.1rem" }}>
                      {project.projectStr}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}>
                      {project.plantLocation.title}
                    </Typography>
                  </Box>
                  <Chip
                    label={`${project.assignedUsers?.length || 0} users`}
                    size="small"
                    color="primary"
                    sx={{
                      fontWeight: 500,
                      borderRadius: 1.5,
                      fontSize: "0.75rem",
                    }}
                  />
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 2.5, pb: 2.5 }}>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle2" fontWeight="500" gutterBottom sx={{ fontSize: "0.85rem" }}>
                    Project Details:
                  </Typography>
                  <Box
                    sx={{
                      p: 1.5,
                      bgcolor: "#f8fafc",
                      borderRadius: 1.5,
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}>
                      <strong>Location:</strong> {project.plantLocation.title} |<strong> DC:</strong>{" "}
                      {project.plantDetail.dcCapacity} |<strong> AC:</strong> {project.plantDetail.acCapacity}
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                  <Typography variant="subtitle2" fontWeight="500" sx={{ fontSize: "0.85rem" }}>
                    Assigned Users:
                  </Typography>
                  <Button
                    size="small"
                    startIcon={<PersonAdd />}
                    onClick={() => {
                      setSelectedProject(project)
                      setOpenProjectDialog(true)
                    }}
                    variant="contained"
                    sx={{
                      textTransform: "none",
                      fontWeight: 500,
                      borderRadius: 1.5,
                      fontSize: "0.75rem",
                    }}
                  >
                    Add User
                  </Button>
                </Box>

                {project.assignedUsers && project.assignedUsers.length > 0 ? (
                  <List sx={{ bgcolor: "#fafafa", borderRadius: 1.5 }}>
                    {project.assignedUsers.map((user, index) => (
                      <ListItem
                        key={user.id}
                        sx={{
                          py: 1.5,
                          borderBottom: index < project.assignedUsers.length - 1 ? "1px solid #e0e0e0" : "none",
                        }}
                      >
                        <Avatar
                          sx={{
                            bgcolor: getAvatarColor(user.id),
                            mr: 1.5,
                            width: 36,
                            height: 36,
                            fontSize: "0.8rem",
                            fontWeight: 500,
                          }}
                        >
                          {getInitials(user.username)}
                        </Avatar>
                        <ListItemText
                          primary={
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <Typography variant="body1" fontWeight="500" sx={{ fontSize: "0.9rem" }}>
                                {user.username}
                              </Typography>
                              <Chip
                                label={getRoleLabel(user.role)}
                                icon={getRoleIcon(user.role)}
                                color={getRoleColor(user.role)}
                                size="small"
                                sx={{ fontSize: "0.65rem", height: 20 }}
                              />
                            </Box>
                          }
                          secondary={<Typography sx={{ fontSize: "0.8rem" }}>{user.email}</Typography>}
                        />
                        <ListItemSecondaryAction>
                          <IconButton
                            edge="end"
                            onClick={() => removeUserFromProject(project._id, user.id)}
                            color="error"
                            size="small"
                            sx={{
                              "&:hover": {
                                bgcolor: "error.light",
                                color: "white",
                              },
                            }}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Box
                    sx={{
                      textAlign: "center",
                      py: 4,
                      bgcolor: "#fafafa",
                      borderRadius: 1.5,
                      border: "2px dashed #e0e0e0",
                    }}
                  >
                    <Group sx={{ fontSize: 36, mb: 1.5, color: "text.disabled" }} />
                    <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic", fontSize: "0.8rem" }}>
                      No users assigned to this project
                    </Typography>
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </TabPanel>
      </Paper>

      {/* User Role Edit Dialog */}
      <Dialog open={openUserRoleDialog} onClose={() => setOpenUserRoleDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ pb: 1.5 }}>
          <Typography variant="h6" fontWeight="600" sx={{ fontSize: "1.2rem" }}>
            Edit User Role - {editingUser?.username}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pt: 1.5 }}>
          <FormControl fullWidth sx={{ mt: 1 }}>
            <InputLabel>User Role</InputLabel>
            <Select
              value={editingUser?.role || "user"}
              onChange={(e) => setEditingUser((prev) => ({ ...prev, role: e.target.value  }))}
              sx={{ borderRadius: 1.5 }}
            >
              <MenuItem value="user">
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <AccountCircle fontSize="small" />
                  User
                </Box>
              </MenuItem>
              <MenuItem value="admin">
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <AdminPanelSettings fontSize="small" />
                  Admin
                </Box>
              </MenuItem>
              <MenuItem value="super_admin">
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <SupervisorAccount fontSize="small" />
                  Super Admin
                </Box>
              </MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ p: 2.5 }}>
          <Button
            onClick={() => setOpenUserRoleDialog(false)}
            sx={{ textTransform: "none", fontWeight: 500, fontSize: "0.85rem" }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (editingUser) {
                updateUserRole(editingUser.id, editingUser.role)
                setOpenUserRoleDialog(false)
                setEditingUser(null)
              }
            }}
            variant="contained"
            sx={{ textTransform: "none", fontWeight: 500, borderRadius: 1.5, fontSize: "0.85rem" }}
          >
            Update Role
          </Button>
        </DialogActions>
      </Dialog>

      {/* Project User Management Dialog */}
      <Dialog open={openProjectDialog} onClose={() => setOpenProjectDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ pb: 1.5 }}>
          <Typography variant="h6" fontWeight="600" sx={{ fontSize: "1.2rem" }}>
            Manage Users - {selectedProject?.projectStr}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pt: 1.5 }}>
          <Typography variant="subtitle2" fontWeight="500" gutterBottom sx={{ mt: 1.5, fontSize: "0.85rem" }}>
            Add User to Project:
          </Typography>
          <Autocomplete
            options={users.filter(
              (user) => !selectedProject?.assignedUsers?.some((assignedUser) => assignedUser.id === user.id),
            )}
            getOptionLabel={(option) => `${option.username} (${option.email}) - ${getRoleLabel(option.role)}`}
            renderOption={(props, option) => (
              <Box component="li" {...props}>
                <Avatar
                  sx={{
                    bgcolor: getAvatarColor(option.id),
                    mr: 1.5,
                    width: 32,
                    height: 32,
                    fontSize: "0.75rem",
                  }}
                >
                  {getInitials(option.username)}
                </Avatar>
                <Box>
                  <Typography variant="body2" fontWeight="500">
                    {option.username}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      {option.email}
                    </Typography>
                    <Chip
                      label={getRoleLabel(option.role)}
                      icon={getRoleIcon(option.role)}
                      color={getRoleColor(option.role)}
                      size="small"
                      sx={{ fontSize: "0.65rem", height: 18 }}
                    />
                  </Box>
                </Box>
              </Box>
            )}
            renderInput={(params) => <TextField {...params} label="Select User" fullWidth size="small" />}
            onChange={(event, value) => {
              if (value && selectedProject) {
                addUserToProject(selectedProject._id, value)
              }
            }}
            sx={{ mb: 3 }}
          />

          <Typography variant="subtitle2" fontWeight="500" gutterBottom sx={{ fontSize: "0.85rem" }}>
            Currently Assigned Users:
          </Typography>
          <List sx={{ bgcolor: "#fafafa", borderRadius: 1.5, maxHeight: 280, overflowY: "auto" }}>
            {selectedProject?.assignedUsers?.map((user) => (
              <ListItem key={user.id} sx={{ py: 1.5 }}>
                <Avatar
                  sx={{
                    bgcolor: getAvatarColor(user.id),
                    mr: 1.5,
                    width: 36,
                    height: 36,
                    fontSize: "0.8rem",
                    fontWeight: 500,
                  }}
                >
                  {getInitials(user.username)}
                </Avatar>
                <ListItemText
                  primary={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography variant="body1" fontWeight="500" sx={{ fontSize: "0.9rem" }}>
                        {user.username}
                      </Typography>
                      <Chip
                        label={getRoleLabel(user.role)}
                        icon={getRoleIcon(user.role)}
                        color={getRoleColor(user.role)}
                        size="small"
                        sx={{ fontSize: "0.65rem", height: 20 }}
                      />
                    </Box>
                  }
                  secondary={<Typography sx={{ fontSize: "0.8rem" }}>{user.email}</Typography>}
                />
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    onClick={() => removeUserFromProject(selectedProject._id, user.id)}
                    color="error"
                    size="small"
                  >
                    <PersonRemove fontSize="small" />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions sx={{ p: 2.5 }}>
          <Button
            onClick={() => setOpenProjectDialog(false)}
            sx={{ textTransform: "none", fontWeight: 500, fontSize: "0.85rem" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* User Project Assignment Dialog */}
      <Dialog open={openUserDialog} onClose={() => setOpenUserDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ pb: 1.5 }}>
          <Typography variant="h6" fontWeight="600" sx={{ fontSize: "1.2rem" }}>
            Assign Projects - {selectedUser?.username}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pt: 1.5 }}>
          <Typography variant="subtitle2" fontWeight="500" gutterBottom sx={{ mt: 1.5, fontSize: "0.85rem" }}>
            Assign to Project:
          </Typography>
          <Autocomplete
            options={projects.filter((project) => !project.assignedUsers?.some((user) => user.id === selectedUser?.id))}
            getOptionLabel={(option) => `${option.projectStr} (${option.plantLocation.title})`}
            renderInput={(params) => <TextField {...params} label="Select Project" fullWidth size="small" />}
            onChange={(event, value) => {
              if (value && selectedUser) {
                addUserToProject(value._id, selectedUser)
              }
            }}
            sx={{ mb: 3 }}
          />

          <Typography variant="subtitle2" fontWeight="500" gutterBottom sx={{ fontSize: "0.85rem" }}>
            Currently Assigned Projects:
          </Typography>
          <List sx={{ bgcolor: "#fafafa", borderRadius: 1.5, maxHeight: 280, overflowY: "auto" }}>
            {getUserProjects(selectedUser?.id || "").map((project) => (
              <ListItem key={project._id} sx={{ py: 1.5 }}>
                <Avatar sx={{ bgcolor: "primary.main", mr: 1.5, width: 36, height: 36 }}>
                  <Business />
                </Avatar>
                <ListItemText
                  primary={
                    <Typography variant="body1" fontWeight="500" sx={{ fontSize: "0.9rem" }}>
                      {project.projectStr}
                    </Typography>
                  }
                  secondary={<Typography sx={{ fontSize: "0.8rem" }}>{project.plantLocation.title}</Typography>}
                />
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    onClick={() => removeUserFromProject(project._id, selectedUser?.id || "")}
                    color="error"
                    size="small"
                  >
                    <PersonRemove fontSize="small" />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions sx={{ p: 2.5 }}>
          <Button
            onClick={() => setOpenUserDialog(false)}
            sx={{ textTransform: "none", fontWeight: 500, fontSize: "0.85rem" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Create Project Dialog */}
      <Dialog
        open={openCreateDialog}
        onClose={() => setOpenCreateDialog(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { maxHeight: "90vh", borderRadius: 2 },
        }}
      >
        <DialogTitle sx={{ pb: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography variant="h6" fontWeight="600" sx={{ fontSize: "1.2rem" }}>
              Create New Project
            </Typography>
            <IconButton onClick={() => setOpenCreateDialog(false)} size="small">
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers sx={{ pt: 2 }}>
          <Grid container spacing={3}>
            {/* Basic Information */}
            <Grid item xs={12}>
              <Typography variant="h6" fontWeight="600" gutterBottom sx={{ color: "primary.main", fontSize: "1.1rem" }}>
                Basic Information
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Project String"
                value={newProject.projectStr}
                onChange={(e) => setNewProject((prev) => ({ ...prev, projectStr: e.target.value }))}
                fullWidth
                required
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
              />
            </Grid>

            {/* Plant Details */}
            <Grid item xs={12}>
              <Typography
                variant="h6"
                fontWeight="600"
                gutterBottom
                sx={{ mt: 1.5, color: "primary.main", fontSize: "1.1rem" }}
              >
                Plant Details
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="DC Capacity"
                value={newProject.plantDetail.dcCapacity}
                onChange={(e) =>
                  setNewProject((prev) => ({
                    ...prev,
                    plantDetail: { ...prev.plantDetail, dcCapacity: e.target.value },
                  }))
                }
                fullWidth
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="AC Capacity"
                value={newProject.plantDetail.acCapacity}
                onChange={(e) =>
                  setNewProject((prev) => ({
                    ...prev,
                    plantDetail: { ...prev.plantDetail, acCapacity: e.target.value },
                  }))
                }
                fullWidth
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Number of Inverters"
                type="number"
                value={newProject.plantDetail.noOfInverter}
                onChange={(e) =>
                  setNewProject((prev) => ({
                    ...prev,
                    plantDetail: { ...prev.plantDetail, noOfInverter: Number.parseInt(e.target.value) || 0 },
                  }))
                }
                fullWidth
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Number of Strings"
                type="number"
                value={newProject.plantDetail.noOfString}
                onChange={(e) =>
                  setNewProject((prev) => ({
                    ...prev,
                    plantDetail: { ...prev.plantDetail, noOfString: Number.parseInt(e.target.value) || 0 },
                  }))
                }
                fullWidth
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Inverter Specification"
                value={newProject.plantDetail.inverterSpecification}
                onChange={(e) =>
                  setNewProject((prev) => ({
                    ...prev,
                    plantDetail: { ...prev.plantDetail, inverterSpecification: e.target.value },
                  }))
                }
                fullWidth
                multiline
                rows={2}
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
              />
            </Grid>

            {/* Plant Location */}
            <Grid item xs={12}>
              <Typography
                variant="h6"
                fontWeight="600"
                gutterBottom
                sx={{ mt: 1.5, color: "primary.main", fontSize: "1.1rem" }}
              >
                Plant Location
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Location Title"
                value={newProject.plantLocation.title}
                onChange={(e) =>
                  setNewProject((prev) => ({
                    ...prev,
                    plantLocation: { ...prev.plantLocation, title: e.target.value },
                  }))
                }
                fullWidth
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Plant Name"
                value={newProject.plantLocation.name}
                onChange={(e) =>
                  setNewProject((prev) => ({
                    ...prev,
                    plantLocation: { ...prev.plantLocation, name: e.target.value },
                  }))
                }
                fullWidth
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="Latitude"
                type="number"
                value={newProject.plantLocation.lattitude}
                onChange={(e) =>
                  setNewProject((prev) => ({
                    ...prev,
                    plantLocation: { ...prev.plantLocation, lattitude: Number.parseFloat(e.target.value) || 0 },
                  }))
                }
                fullWidth
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="Longitude"
                type="number"
                value={newProject.plantLocation.longitude}
                onChange={(e) =>
                  setNewProject((prev) => ({
                    ...prev,
                    plantLocation: { ...prev.plantLocation, longitude: Number.parseFloat(e.target.value) || 0 },
                  }))
                }
                fullWidth
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="Altitude"
                value={newProject.plantLocation.altitude}
                onChange={(e) =>
                  setNewProject((prev) => ({
                    ...prev,
                    plantLocation: { ...prev.plantLocation, altitude: e.target.value },
                  }))
                }
                fullWidth
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
              />
            </Grid>

            {/* Data Availability Settings */}
            <Grid item xs={12}>
              <Typography
                variant="h6"
                fontWeight="600"
                gutterBottom
                sx={{ mt: 1.5, color: "primary.main", fontSize: "1.1rem" }}
              >
                Data Availability Settings
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Time Interval</InputLabel>
                <Select
                  value={newProject.plantDataAvailability.timeInterval}
                  onChange={(e) =>
                    setNewProject((prev) => ({
                      ...prev,
                      plantDataAvailability: { ...prev.plantDataAvailability, timeInterval: e.target.value },
                    }))
                  }
                  sx={{ borderRadius: 1.5 }}
                >
                  <MenuItem value="1_min">1 Minute</MenuItem>
                  <MenuItem value="5_min">5 Minutes</MenuItem>
                  <MenuItem value="15_min">15 Minutes</MenuItem>
                  <MenuItem value="1_hour">1 Hour</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={newProject.plantDataAvailability.netContractual}
                      onChange={(e) =>
                        setNewProject((prev) => ({
                          ...prev,
                          plantDataAvailability: { ...prev.plantDataAvailability, netContractual: e.target.checked },
                        }))
                      }
                    />
                  }
                  label={<Typography sx={{ fontSize: "0.85rem" }}>Net Contractual</Typography>}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={newProject.plantDataAvailability.netPVsyst}
                      onChange={(e) =>
                        setNewProject((prev) => ({
                          ...prev,
                          plantDataAvailability: { ...prev.plantDataAvailability, netPVsyst: e.target.checked },
                        }))
                      }
                    />
                  }
                  label={<Typography sx={{ fontSize: "0.85rem" }}>Net PVsyst</Typography>}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={newProject.plantDataAvailability.inverterEfficiency}
                      onChange={(e) =>
                        setNewProject((prev) => ({
                          ...prev,
                          plantDataAvailability: {
                            ...prev.plantDataAvailability,
                            inverterEfficiency: e.target.checked,
                          },
                        }))
                      }
                    />
                  }
                  label={<Typography sx={{ fontSize: "0.85rem" }}>Inverter Efficiency</Typography>}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={newProject.plantDataAvailability.realtimeData}
                      onChange={(e) =>
                        setNewProject((prev) => ({
                          ...prev,
                          plantDataAvailability: { ...prev.plantDataAvailability, realtimeData: e.target.checked },
                        }))
                      }
                    />
                  }
                  label={<Typography sx={{ fontSize: "0.85rem" }}>Realtime Data</Typography>}
                />
              </Box>
            </Grid>

            {/* Calculation Data */}
            <Grid item xs={12}>
              <Typography
                variant="h6"
                fontWeight="600"
                gutterBottom
                sx={{ mt: 1.5, color: "primary.main", fontSize: "1.1rem" }}
              >
                Calculation Data
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="AC Capacity (kW)"
                type="number"
                value={newProject.calculationData.ac_capacity}
                onChange={(e) =>
                  setNewProject((prev) => ({
                    ...prev,
                    calculationData: { ...prev.calculationData, ac_capacity: Number.parseInt(e.target.value) || 0 },
                  }))
                }
                fullWidth
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="DC Capacity (kW)"
                type="number"
                value={newProject.calculationData.dc_capacity}
                onChange={(e) =>
                  setNewProject((prev) => ({
                    ...prev,
                    calculationData: { ...prev.calculationData, dc_capacity: Number.parseInt(e.target.value) || 0 },
                  }))
                }
                fullWidth
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Actual PR Formula"
                value={newProject.calculationFormula.actualPR}
                onChange={(e) =>
                  setNewProject((prev) => ({
                    ...prev,
                    calculationFormula: { ...prev.calculationFormula, actualPR: e.target.value },
                  }))
                }
                fullWidth
                multiline
                rows={3}
                placeholder="Enter calculation formula for actual PR"
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => setOpenCreateDialog(false)}
            startIcon={<Cancel />}
            sx={{ textTransform: "none", fontWeight: 500, fontSize: "0.85rem" }}
          >
            Cancel
          </Button>
          <Button
            onClick={createNewProject}
            variant="contained"
            startIcon={<Save />}
            disabled={!newProject.projectStr}
            sx={{
              textTransform: "none",
              fontWeight: 500,
              borderRadius: 1.5,
              px: 2.5,
              fontSize: "0.85rem",
            }}
          >
            Create Project
          </Button>
        </DialogActions>
      </Dialog>

      {/* Update Project Dialog */}
      <Dialog
        open={openUpdateDialog}
        onClose={() => setOpenUpdateDialog(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { maxHeight: "90vh", borderRadius: 2 },
        }}
      >
        <DialogTitle sx={{ pb: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography variant="h6" fontWeight="600" sx={{ fontSize: "1.2rem" }}>
              Update Project - {updateProject?.projectStr}
            </Typography>
            <IconButton onClick={() => setOpenUpdateDialog(false)} size="small">
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers sx={{ pt: 2 }}>
          {updateProject && (
            <Grid container spacing={3}>
              {/* Basic Information */}
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  fontWeight="600"
                  gutterBottom
                  sx={{ color: "primary.main", fontSize: "1.1rem" }}
                >
                  Basic Information
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Project String"
                  value={updateProject.projectStr}
                  onChange={(e) => setUpdateProject((prev) => ({ ...prev, projectStr: e.target.value }))}
                  fullWidth
                  required
                  size="small"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                />
              </Grid>

              {/* Plant Details */}
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  fontWeight="600"
                  gutterBottom
                  sx={{ mt: 1.5, color: "primary.main", fontSize: "1.1rem" }}
                >
                  Plant Details
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="DC Capacity"
                  value={updateProject.plantDetail.dcCapacity}
                  onChange={(e) =>
                    setUpdateProject((prev) => ({
                      ...prev,
                      plantDetail: { ...prev.plantDetail, dcCapacity: e.target.value },
                    }))
                  }
                  fullWidth
                  size="small"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="AC Capacity"
                  value={updateProject.plantDetail.acCapacity}
                  onChange={(e) =>
                    setUpdateProject((prev) => ({
                      ...prev,
                      plantDetail: { ...prev.plantDetail, acCapacity: e.target.value },
                    }))
                  }
                  fullWidth
                  size="small"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Number of Inverters"
                  type="number"
                  value={updateProject.plantDetail.noOfInverter}
                  onChange={(e) =>
                    setUpdateProject((prev) => ({
                      ...prev,
                      plantDetail: { ...prev.plantDetail, noOfInverter: Number.parseInt(e.target.value) || 0 },
                    }))
                  }
                  fullWidth
                  size="small"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Number of Strings"
                  type="number"
                  value={updateProject.plantDetail.noOfString}
                  onChange={(e) =>
                    setUpdateProject((prev) => ({
                      ...prev,
                      plantDetail: { ...prev.plantDetail, noOfString: Number.parseInt(e.target.value) || 0 },
                    }))
                  }
                  fullWidth
                  size="small"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Inverter Specification"
                  value={updateProject.plantDetail.inverterSpecification}
                  onChange={(e) =>
                    setUpdateProject((prev) => ({
                      ...prev,
                      plantDetail: { ...prev.plantDetail, inverterSpecification: e.target.value },
                    }))
                  }
                  fullWidth
                  multiline
                  rows={2}
                  size="small"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                />
              </Grid>

              {/* Plant Location */}
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  fontWeight="600"
                  gutterBottom
                  sx={{ mt: 1.5, color: "primary.main", fontSize: "1.1rem" }}
                >
                  Plant Location
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Location Title"
                  value={updateProject.plantLocation.title}
                  onChange={(e) =>
                    setUpdateProject((prev) => ({
                      ...prev,
                      plantLocation: { ...prev.plantLocation, title: e.target.value },
                    }))
                  }
                  fullWidth
                  size="small"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Plant Name"
                  value={updateProject.plantLocation.name}
                  onChange={(e) =>
                    setUpdateProject((prev) => ({
                      ...prev,
                      plantLocation: { ...prev.plantLocation, name: e.target.value },
                    }))
                  }
                  fullWidth
                  size="small"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Latitude"
                  type="number"
                  value={updateProject.plantLocation.lattitude}
                  onChange={(e) =>
                    setUpdateProject((prev) => ({
                      ...prev,
                      plantLocation: { ...prev.plantLocation, lattitude: Number.parseFloat(e.target.value) || 0 },
                    }))
                  }
                  fullWidth
                  size="small"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Longitude"
                  type="number"
                  value={updateProject.plantLocation.longitude}
                  onChange={(e) =>
                    setUpdateProject((prev) => ({
                      ...prev,
                      plantLocation: { ...prev.plantLocation, longitude: Number.parseFloat(e.target.value) || 0 },
                    }))
                  }
                  fullWidth
                  size="small"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Altitude"
                  value={updateProject.plantLocation.altitude}
                  onChange={(e) =>
                    setUpdateProject((prev) => ({
                      ...prev,
                      plantLocation: { ...prev.plantLocation, altitude: e.target.value },
                    }))
                  }
                  fullWidth
                  size="small"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                />
              </Grid>

              {/* Data Availability Settings */}
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  fontWeight="600"
                  gutterBottom
                  sx={{ mt: 1.5, color: "primary.main", fontSize: "1.1rem" }}
                >
                  Data Availability Settings
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="small">
                  <InputLabel>Time Interval</InputLabel>
                  <Select
                    value={updateProject.plantDataAvailability.timeInterval}
                    onChange={(e) =>
                      setUpdateProject((prev) => ({
                        ...prev,
                        plantDataAvailability: { ...prev.plantDataAvailability, timeInterval: e.target.value },
                      }))
                    }
                    sx={{ borderRadius: 1.5 }}
                  >
                    <MenuItem value="1_min">1 Minute</MenuItem>
                    <MenuItem value="5_min">5 Minutes</MenuItem>
                    <MenuItem value="15_min">15 Minutes</MenuItem>
                    <MenuItem value="1_hour">1 Hour</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={updateProject.plantDataAvailability.netContractual}
                        onChange={(e) =>
                          setUpdateProject((prev) => ({
                            ...prev,
                            plantDataAvailability: { ...prev.plantDataAvailability, netContractual: e.target.checked },
                          }))
                        }
                      />
                    }
                    label={<Typography sx={{ fontSize: "0.85rem" }}>Net Contractual</Typography>}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={updateProject.plantDataAvailability.netPVsyst}
                        onChange={(e) =>
                          setUpdateProject((prev) => ({
                            ...prev,
                            plantDataAvailability: { ...prev.plantDataAvailability, netPVsyst: e.target.checked },
                          }))
                        }
                      />
                    }
                    label={<Typography sx={{ fontSize: "0.85rem" }}>Net PVsyst</Typography>}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={updateProject.plantDataAvailability.inverterEfficiency}
                        onChange={(e) =>
                          setUpdateProject((prev) => ({
                            ...prev,
                            plantDataAvailability: {
                              ...prev.plantDataAvailability,
                              inverterEfficiency: e.target.checked,
                            },
                          }))
                        }
                      />
                    }
                    label={<Typography sx={{ fontSize: "0.85rem" }}>Inverter Efficiency</Typography>}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={updateProject.plantDataAvailability.realtimeData}
                        onChange={(e) =>
                          setUpdateProject((prev) => ({
                            ...prev,
                            plantDataAvailability: { ...prev.plantDataAvailability, realtimeData: e.target.checked },
                          }))
                        }
                      />
                    }
                    label={<Typography sx={{ fontSize: "0.85rem" }}>Realtime Data</Typography>}
                  />
                </Box>
              </Grid>

              {/* Calculation Data */}
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  fontWeight="600"
                  gutterBottom
                  sx={{ mt: 1.5, color: "primary.main", fontSize: "1.1rem" }}
                >
                  Calculation Data
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="AC Capacity (kW)"
                  type="number"
                  value={updateProject.calculationData.ac_capacity}
                  onChange={(e) =>
                    setUpdateProject((prev) => ({
                      ...prev,
                      calculationData: { ...prev.calculationData, ac_capacity: Number.parseInt(e.target.value) || 0 },
                    }))
                  }
                  fullWidth
                  size="small"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="DC Capacity (kW)"
                  type="number"
                  value={updateProject.calculationData.dc_capacity}
                  onChange={(e) =>
                    setUpdateProject((prev) => ({
                      ...prev,
                      calculationData: { ...prev.calculationData, dc_capacity: Number.parseInt(e.target.value) || 0 },
                    }))
                  }
                  fullWidth
                  size="small"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Actual PR Formula"
                  value={updateProject.calculationFormula.actualPR}
                  onChange={(e) =>
                    setUpdateProject((prev) => ({
                      ...prev,
                      calculationFormula: { ...prev.calculationFormula, actualPR: e.target.value },
                    }))
                  }
                  fullWidth
                  multiline
                  rows={3}
                  placeholder="Enter calculation formula for actual PR"
                  size="small"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => setOpenUpdateDialog(false)}
            startIcon={<Cancel />}
            sx={{ textTransform: "none", fontWeight: 500, fontSize: "0.85rem" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpdateProject}
            variant="contained"
            startIcon={<Update />}
            disabled={!updateProject?.projectStr}
            sx={{
              textTransform: "none",
              fontWeight: 500,
              borderRadius: 1.5,
              px: 2.5,
              fontSize: "0.85rem",
            }}
          >
            Update Project
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  )
}
